import React from 'react';
import { Building2, Home, CalendarDays, UserCog, Check, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { services } from '../../data/mock';

const iconMap = {
  1: Building2,
  2: Home,
  3: CalendarDays,
  4: UserCog,
};

const ServicesSection = () => {
  return (
    <section id="services" className="bg-black py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-[#00FFD1] text-sm font-medium tracking-wide uppercase mb-4">
            Our Services
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
            Comprehensive Armed Security Solutions
          </h2>
          <p className="text-lg text-white/70 leading-relaxed">
            From commercial properties to high-profile events, our licensed armed guards provide professional protection tailored to your specific needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.id];
            return (
              <div
                key={service.id}
                className="group bg-[#121212] border border-white/10 hover:border-[#00FFD1]/30 p-8 transition-all duration-400"
              >
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center border border-[#00FFD1]/30 group-hover:bg-[#00FFD1]/10 transition-all duration-400">
                    <Icon className="w-7 h-7 text-[#00FFD1]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-semibold text-white mb-3">
                      {service.title}
                    </h3>
                    <p className="text-white/70 text-base leading-relaxed mb-6">
                      {service.description}
                    </p>
                    <ul className="space-y-3">
                      {service.benefits.map((benefit, index) => (
                        <li key={index} className="flex items-center gap-3">
                          <Check className="w-5 h-5 text-[#00FFD1] flex-shrink-0" />
                          <span className="text-white/85">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <Button
            className="bg-[#00FFD1] text-black hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] rounded-none px-8 py-6 text-lg font-medium transition-all duration-400 inline-flex items-center gap-3"
          >
            Discuss Your Security Needs
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
